import { capitalize, chain, escapeRegExp, isNil } from "lodash"

// The difference with lodash startCase is it will keep special characters such as %
export const titleCase = string => chain(string)
  .split(" ")
  .map(capitalize)
  .join(" ")
  .value()

export function createEscapedRegExp(value, { caseInsensitive = true } = {}) {
  let options = "g"

  if (caseInsensitive) {
    options += "i"
  }

  return new RegExp(escapeRegExp(value), options)
}

export function createMatch(searchValue) {
  const matcher = createEscapedRegExp(searchValue)

  return (value) => {
    if (value && value.match(matcher)) {
      return true
    }

    return false
  }
}

/**
 * Safely removes HTML tags and decodes HTML entities from a string
 * Uses DOMParser for secure HTML parsing without script execution risks
 * @param {string} html - The HTML string to sanitize
 * @returns {string} - The plain text content
 */
export function stripHtml(html) {
  if (typeof html !== "string") {
    return html
  }

  try {
    // Use DOMParser for safer HTML parsing (no script execution)
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, "text/html")

    return doc.body.textContent || doc.body.innerText || ""
  } catch {
    return html.replace(/<[^>]*>/g, "")
  }
}

export function camelCaseToSpace(value) {
  if (isNil(value)) {
    return value
  }
  return value.replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/^./, (str) => str.toUpperCase())
}

export function snakeCaseToSpace(value) {
  if (isNil(value)) {
    return value
  }
  return value.replace(/_/g, " ")
    .replace(/^./, (str) => str.toUpperCase())
}

export function camelToUpperSnake(value) {
  return value.replace(/([a-z])([A-Z])/g, "$1_$2").toUpperCase()
}
